/**
 * Theme Scripts Entrypoint.
 *
 * This file serves as a place to import all of the JS that will eventually be bundled by Webpack to form the production-ready version.
 *
 * TODO:
 *
 * - Replicate all functionality here into React components.
 * - For global things like the scroll smoother, think about how to split between ready/load-critical events
 *
 * - For global scroll smoother stuff, think about how to encapsulate sticky things
 * - Abstract out "color-changing magic" things like the header and subnavss
 *
 * @author Nick Patterson <nick@fifteen4.com>
 */

/** Dependencies -------------------------------------------- */

import QuickNDirtyPopoverModals from './includes/_quick-n-dirty/popover-modals'

import SmoothScroll from './includes/smooth-scroll'
import Slider from './includes/slider'
import HoverTimer from './includes/hover-timer'

import accordion from './includes/accordion'
import header from './includes/header'
import filter from './includes/filter'
import preloader from './includes/preloader'
// import subnav from './includes/subnav'
import superhero from './includes/superhero'
import tabs from './includes/tabs'

import GravityFormsIntegration from './includes/integrations/gravity-forms'

/** Initialization ------------------------------------------ */

const quickNDirtyPopoverModals = new QuickNDirtyPopoverModals( 'c-popover-modal', 'js-popover-modal' )

const smoothScroll = new SmoothScroll( 'smooth-scroll' )
const slider = new Slider( 'c-slider', 'c-slide', {} )
const hoverTimer = new HoverTimer()

const gravityFormsIntegration = new GravityFormsIntegration()

function onDomContentLoaded() {

	quickNDirtyPopoverModals.init()

	slider.init()
	filter.init( { selector: '[data-filter]' } )
	header.init( { selector: '[data-header]' } )
	accordion.init( { className: 'c-accordion' } )
	// subnav.init({ className: 'c-subnav' })
	tabs.init( { selector: '.c-tabs' } )

	gravityFormsIntegration.init()
}

function onPageShow() {
	
	smoothScroll.init()
	slider.animate()
	hoverTimer.initialize()

	superhero.init({
		className: 'c-superhero',
		config: {
			animationPath: null,
		},
	});

	preloader.init( { selector: '.c-preloader' } )
}

if ( document.readyState !== 'loading' ) {
	onDomContentLoaded()
}
else {
	window.addEventListener( 'DOMContentLoaded', onDomContentLoaded )
}

window.addEventListener( 'pageshow', onPageShow )
